import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceListRenderComponent } from './piece-list-render.component';


export const pieceListRenderModuleEntryComponents = [
  PieceListRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: pieceListRenderModuleEntryComponents
})
export class PieceListRenderModule {}

export default pieceListRenderModuleEntryComponents;
